import { useEffect } from 'react';

import { currentOS, OS } from '../../../lib/platform';
import { VariablesButton } from '../../logic/variables/VariablesButton';

import { useI18n } from '../../../hooks/useI18nFormatters';

import { cssClass } from '../../../theme/cssClass';
import { glyph } from '../../../theme/glyph';
import { theme } from '../../../theme/theme';

import { MonoButtonRound } from '../../../components/buttons/MonoButtonRound';
import { HeaderActionsContainer } from '../../../components/header/HeaderActionsContainer';

import { flowEditor, useFlowEditor } from './useFlowEditor';

export function FlowActions(props) {
  const { i18n } = useI18n();
  const { history, historyIndex } = useFlowEditor();

  const canUndo = history[historyIndex - 1] != null;
  const canRedo = history[historyIndex + 1] != null;

  useEffect(() => {
    function handleKeyDown(event) {
      let isUndo;
      let isRedo;

      const key = event.key?.toLowerCase() ?? null;

      switch (currentOS) {
        case OS.MACOS:
          isUndo = event.metaKey && !event.shiftKey && key === 'z';
          isRedo = event.metaKey && event.shiftKey && key === 'z';
          break;
        default:
          isUndo = event.ctrlKey && key === 'z';
          isRedo =
            (event.ctrlKey && key === 'y') || (event.ctrlKey && event.shiftKey && key === 'z');
          break;
      }

      if (isRedo) {
        event.preventDefault();
        flowEditor.redo();
      } else if (isUndo) {
        event.preventDefault();
        flowEditor.undo();
      }
    }

    document.documentElement.addEventListener('keydown', handleKeyDown);

    return function () {
      document.documentElement.removeEventListener('keydown', handleKeyDown);
    };
  });

  return (
    <HeaderActionsContainer>
      <MonoButtonRound
        title={i18n.messageFormatter('common.undo')}
        isDisabled={canUndo === false}
        onPress={() => {
          flowEditor.undo();
        }}
      >
        <MonoButtonRound.Icon
          source={glyph.core.arrowCounterclockwise}
          size={theme.icon.size_medium}
        />
        <MonoButtonRound.Text className={cssClass.showForLarge}>
          {i18n.messageFormatter('common.undo')}
        </MonoButtonRound.Text>
      </MonoButtonRound>

      <MonoButtonRound
        title={i18n.messageFormatter('common.redo')}
        isDisabled={canRedo === false}
        onPress={() => {
          flowEditor.redo();
        }}
      >
        <MonoButtonRound.Icon source={glyph.core.arrowClockwise} size={theme.icon.size_medium} />
        <MonoButtonRound.Text className={cssClass.showForLarge}>
          {i18n.messageFormatter('common.redo')}
        </MonoButtonRound.Text>
      </MonoButtonRound>

      <VariablesButton />
    </HeaderActionsContainer>
  );
}
